import React from "react";
import Text from "components/Text";
import Card from "components/Card";
import alertIcon from "../../../../assets/images/redAlert.svg";
import { withTranslation } from "react-i18next";
import styles from "../Dashboard.module.scss";
import CommentIcon from "../../../../assets/images/comment_icon.svg";
import moment from "moment";

const StaffDetailsCard = ({ t, assigneeList, onHeadingClick }) => {
  function checkOverdueTasks(due, overallStatus) {
    const now = moment.utc();
    const dueDate = moment.utc(due);
    const Overdue = dueDate?.isBefore(now);
    let status = getStatus(overallStatus);
    if (Overdue) {
      if (status === "Pending" || status === "Accepted" || status === "Started")
        return true;
    } else {
      return false;
    }
  }

  const getStatus = (overallStatus) => {
    const statusMap = {
      1: "In Progress",
      2: "Pending",
      3: "Accepted",
      4: "Started",
      5: "Completed",
      6: "Rejected",
      7: "Cancelled",
    };
    return statusMap[overallStatus] || "";
  };

  const getPriority = (priority) => {
    const priorityMap = {
      1: "HIGH",
      2: "MEDIUM",
      3: "LOW",
    };
    return priorityMap[priority] || "All";
  };

  const getButtonClass = (status) => {
    const statusClasses = {
      Pending: styles.Pending,
      Cancelled: styles.Cancelled,
      Started: styles.Started,
      Accepted: styles.Accepted,
      Rejected: styles.Rejected,
      "In Progress": styles.InProgress,
      Completed: styles.Completed,
    };

    return `${styles.status_btn} ${statusClasses[status] || ""}`;
  };

  return (
    <>
      {assigneeList?.map((assignee) => {
        return (
          <Card
            className={styles.task_card}
            onClick={() => onHeadingClick(assignee)}
          >
            {checkOverdueTasks(assignee?.dueDate, assignee?.status) && (
              <div className={styles["alert_text_wrapper"]}>
                <img src={alertIcon} alt="Exlamatory_Icon" className="mr-2" />
                <Text size="11px" weight="400" color="#EE4F4F">
                  {t("taskManagement.taskOverdue")}
                </Text>
              </div>
            )}
            <div className={styles["btn_dropdown_wrapper"]}>
              <div className={styles["status_priority_date_wrapper"]}>
                <button
                  className={
                    styles.btn_style +
                    " border-0 " +
                    " " +
                    getButtonClass(getStatus(assignee?.status))
                  }
                >
                  {getStatus(assignee?.status)}
                </button>
              </div>
            </div>
            <Text size="16px" weight="600" color="#587E85" marginTop="12px">
              {`${assignee?.user?.firstName} ${assignee?.user?.lastName}`}
            </Text>
            <div className={styles.dental_name_comment_new + " " + "mt-1"}>
              <div>
                <Text size="12px" weight="400" color="#6F7788">
                  {assignee?.office?.name}
                </Text>
              </div>
              <div className="d-flex align-items-center gap-3">
                <img
                  style={{ display: "inline-block" }}
                  src={CommentIcon}
                  alt="download-icon"
                  className="mr-1"
                />
                <Text size="12px" weight="400" color="#6F7788">
                  {`${assignee?.totalComments} comments`}
                </Text>
              </div>
            </div>
          </Card>
        );
      })}
    </>
  );
};

export default withTranslation()(StaffDetailsCard);
